export default __webpack_public_path__ + "static/media/githubOnboarding.990539bb.svg";